const NavigationIcon = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_2045_2389)">
        <path
          d="M15.1517 3.33727L14.5855 4.70453L9.72413 16.637L9.18551 17.9766L8.59165 16.6646L6.47862 12.0104L1.82442 9.89735L0.512407 9.30349L1.85204 8.76487L13.7845 3.90351L15.1517 3.33727ZM12.9006 5.58842L3.66124 9.35873L7.21059 10.9746L7.41775 11.0713L7.51442 11.2784L9.13027 14.8278L12.9006 5.58842Z"
          fill="#251000"
          fill-opacity="0.56"
        />
      </g>
      <defs>
        <clipPath id="clip0_2045_2389">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(-1 0 0 1 20 0)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NavigationIcon
